import { galleryImages } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeading } from './SectionHeading';

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="gallery" className="py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading label={t.gallerySection.label} title={t.gallerySection.title} />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 lg:gap-3">
          {galleryImages.map((item) => (
            <div
              key={item.id}
              className="group aspect-square overflow-hidden bg-surface border border-white/5"
              data-testid={`gallery-item-${item.id}`}
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
